import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/default.png'


const _withScopeId = n => (_pushScopeId("data-v-b1c47a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-col-11" }
const _hoisted_2 = { class: "w-100 p-d-flex p-justify-between p-mb-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "titile-managment" }, "Campaign Management", -1))
const _hoisted_4 = { class: "p-d-flex main-name-block" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  class: "campaign-photo"
}
const _hoisted_7 = { class: "campaign-name" }
const _hoisted_8 = { class: "campaign-name" }
const _hoisted_9 = { class: "date-slot" }
const _hoisted_10 = { class: "budget" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campaigns_list_counters = _resolveComponent("campaigns-list-counters")!
  const _component_empty_list = _resolveComponent("empty-list")!
  const _component_search_bar = _resolveComponent("search-bar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_status_chip = _resolveComponent("status-chip")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, {
    loading: _ctx.loading,
    class: "padd-box"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.user.isBrandOwner())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "red-button create-campaig n",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'create-campaign' })))
                }, " create Campaign "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_campaigns_list_counters, { counters: _ctx.counters }, null, 8, ["counters"]),
          (!_ctx.campaigns?.length )
            ? (_openBlock(), _createBlock(_component_empty_list, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_search_bar, {
            class: "w-100",
            onClearFilters: _ctx.clearFilters,
            onSearchValue: _ctx.searchValueChange,
            "options-name": 'campaign type',
            onSendName: _ctx.sendName,
            onIsAllSelected: _ctx.isAllSelected,
            onSelectAll: _ctx.selectAllPlatforms,
            onAddPlatform: _ctx.addPlatform,
            options: _ctx.platformsOptions,
            placeholder: 'Search for Campaign'
          }, null, 8, ["onClearFilters", "onSearchValue", "onSendName", "onIsAllSelected", "onSelectAll", "onAddPlatform", "options"])
        ]),
        _createVNode(_component_DataTable, {
          value: _ctx.filteredCampaigns,
          responsiveLayout: "scroll",
          class: "p-mt-6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Campaign",
              sortable: true
            }, {
              body: _withCtx((campaign) => [
                _createElementVNode("section", _hoisted_4, [
                  (campaign.data.photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: campaign.data.photo,
                        class: "campaign-photo"
                      }, null, 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(campaign.data.name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "status",
              header: "Status",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_status_chip, {
                  status: data.status
                }, null, 8, ["status"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "targetMarket.title",
              header: "Market",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(data?.targetMarket.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "dates.endDate",
              header: "Time left",
              sortable: true
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatDate(slotProps.data.dates.endDate) || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "price",
              header: "Price",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.compactNumber(data?.budget?.amount)) + " " + _toDisplayString(data.budget.currency), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "action",
              header: "",
              sortable: false
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: "budget view-detail",
                  onClick: ($event: any) => (_ctx.$router.push({
             name: 'campaigns-stats', params: { campaignID: data.id }}))
                }, "View Details", 8, _hoisted_11)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}